import { List, styled } from "@mui/material";

export const ListStyled = styled(List)(({
    theme
}) => ({
    marginLeft: theme.spacing(4) 
}));
